export { default } from "./PlayerScoreArea";
